<style scoped>
/deep/ .table_header {
  background-color: #F0F0F0 !important;
}

.p20 {
  padding: 0 20px;
}

.new-content {
  padding-top: 0;
  padding-left: 32px;
  background: #fff;
  margin-bottom: 4px;
  padding-bottom: 10px;
}

.task-header {
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  padding-bottom: 10px;
}

.task-content .item {
  display: flex;
  color: #666666;
  font-size: 14px;
}

.task-content .item div {

  padding-right: 20px;
  margin-right: 20px;
  border-right: 1px solid #E5E5E5;
  margin-top: 10px;
}

.task-content .item .last {
  border-right: 1px solid transparent;
}

.template-detail {
  cursor: pointer;
  color: #4fa1a4;
}
</style>
<template>
  <div class="task-content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="header">
      <div class="back" @click="$router.go(-1)">返回</div>
      <div class="task-title">
        服务商任务包
      </div>
    </div>
    <div class="title">
      任务包信息
    </div>
    <div class="new-content">
      <div class="task-content">
        <section class="item">
          <div>公司名称：{{ detail.tenantName }}</div>
          <div>组织名称：{{ detail.organisationName }}</div>
          <div class="last">计划年份：{{ detail.planYear }}年度</div>
        </section>
      </div>
    </div>

    <!-- 任务明细 开始 -->
    <div class="title">
      任务明细
      <el-button @click="exportPlan" class="export-btn" size="mini" type="info">导出</el-button>
    </div>

    <div class="back-color-fff  content-main-box"  :style="'height:' + contentMainHeight + 'px;'" style="padding:10px 20px 30px 20px;">
      <el-table :data="detail.marketingPlanDetailList" tooltip-effect="light" stripe border header-cell-class-name="table_header">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="detailTerritoryList" label="区域" show-overflow-tooltip header-align="center" align="left"
          width="140">
          <template slot-scope="scope">{{ scope.row.detailTerritoryList | listFilter }}</template>
        </el-table-column>
        <el-table-column prop="generalBudget" label="终端服务总预算" show-overflow-tooltip header-align="center" align="left"
          width="140">
          <template slot-scope="scope">{{ scope.row.generalBudget | numDigit }}元</template>
        </el-table-column>
        <el-table-column label="月度预算" header-align="center">
          <el-table-column v-for="(item, index) in monthData" :key="index" :prop="item.fieldName" :label="item.title"
            show-overflow-tooltip header-align="center" align="right" width="120">
            <template slot-scope="scope">{{ scope.row[item.fieldName] | numDigit }}元</template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="needPersonNum" label="所需人数" show-overflow-tooltip header-align="center" align="right"
          width="110">

        </el-table-column>
        <el-table-column prop="templateDetailJson" label="终端服务内容" show-overflow-tooltip header-align="center" align="left"
          width="200">
          <template slot-scope="scope">
            <div class="template-detail" @click="rowDetail = scope.row.templateDetailJson; showRowDetail = true">
              {{ getTaskName(scope.row.templateDetailJson) }}
            </div>

          </template>

        </el-table-column>
        <el-table-column prop="servicerName" label="服务商" show-overflow-tooltip header-align="center" align="left"
          width="200">
        </el-table-column>
        <el-table-column prop="contractName" label="合同名称" show-overflow-tooltip header-align="center" align="left"
          width="160">
          <template slot-scope="scope">
            {{scope.row.contractName || '-'}}
          </template>
        </el-table-column>
        <el-table-column prop="monthMaxMoney" label="月度合作上限" show-overflow-tooltip header-align="center" align="right"
          width="200">
          <template slot-scope="scope">{{ scope.row.monthMaxMoney | numDigit }}元</template>
        </el-table-column>
      </el-table>
    </div>
    <PersonTaskSum :detail="rowDetail" v-if="showRowDetail" @close="showRowDetail = false;"></PersonTaskSum>
  </div>
</template>

<script>
import moment from 'moment';
import PersonTaskSum from './components/PersonTaskSum.vue';
export default {
  components: {
    PersonTaskSum
  },
  data() {
    return {
      rowDetail: {},
      showRowDetail: false,
      tableData: [],
      detail: {},
      monthData: [
        { title: '1月', fieldName: 'januaryBudget' },
        { title: '2月', fieldName: 'februaryBudget' },
        { title: '3月', fieldName: 'marchBudget' },
        { title: '4月', fieldName: 'aprilBudget' },
        { title: '5月', fieldName: 'mayBudget' },
        { title: '6月', fieldName: 'juneBudget' },
        { title: '7月', fieldName: 'julyBudget' },
        { title: '8月', fieldName: 'augustBudget' },
        { title: '9月', fieldName: 'septemberBudget' },
        { title: '10月', fieldName: 'octoberBudget' },
        { title: '11月', fieldName: 'novemberBudget' },
        { title: '12月', fieldName: 'decemberBudget' },
      ],

    };
  },
  filters: {
    listFilter(list) {
      let str='-'
      if(list&&list.length>0){
        // 区域
        let nameList=list.map((k)=>{
          return k.salesTerritoryName;
        });
        str=nameList.join('、')
      }
      return str
    }
  },
  created() {
    this.getDetail();
  },
  methods: {

    getDetail() {
      var self = this;
      if (!this.$route.query.guid) return;
      var req = {
        marketingPlanGuid: this.$route.query.guid,
        servicerGuid:localStorage.guid,
      };
      this.fullscreenLoading = true;
      self.api.get(`/${serverConfig.msSalesPerformService}/marketing-plan/detail`, req).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.detail = res.data.data;
          this.$forceUpdate();
        } else {
          self.$message.error(res.data.msg);
        }
      });

    },
    getTaskName(list) {
      let name = '-';
      if (list && list.length == 1) {
        name = list[0].taskContentName;
      }
      if (list && list.length > 1) {
        name = list[0].taskContentName + '等' + list.length + '个任务';
      }
      return name;
    },
    exportPlan() {
      this.fullscreenLoading = true;
      this.api.postJsonD(`/${serverConfig.msSalesPerformService}/marketing-plan/export-data?marketingPlanGuid=${this.$route.query.guid}&servicerGuid=${localStorage.guid}`)
        .then(res => {
          this.fullscreenLoading = false;
          let blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          let fileName = this.detail.tenantName+ '-服务商任务包-' + this.$moment(new Date()).format('YYYYMMDD');
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a')
          link.download = fileName;
          link.href = objectUrl;
          link.click();

        });
    },
  }
};
</script> 
<style scoped>
.title-search {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: center;

}

.search-box {
  width: 260px
}

.content {
  background: #fff;
  font-size: 18px;
}

/deep/.el-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

/deep/.el-form-item__content {
  margin-left: 0px !important;
}

.base-info {
  display: flex;
  align-items: center;
  margin-left: 23px;
  margin-bottom: 10px;
}

.base-info .base-title {
  word-break: keep-all;
  font-size: 14px;
  display: flex;
}

.depart-choose {
  width: 300px;
  height: 34px;
  border: 1px solid #dcdfe6;
  box-sizing: content-box;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-left: 6px;
}

.depart-choose span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.place-choose {
  padding-left: 10px;
  color: rgb(185, 185, 185);
}

.place-show {
  padding-left: 20px;
}

.p16 {
  padding-top: 0;
  padding-left: 30px;
  padding-right: 30px;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.management-list {
  display: flex;
  align-items: center;
  margin-left: 64px;
  margin-bottom: 20px;
  font-size: 14px;
  color: #606266;
}

.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}

.management-name {
  flex-shrink: 0;
}

.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  /* border: 1px solid grey; */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
  border-radius: 20px;
  background: #DEEFEF;
  border: 0 none;
}

.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}

.input-item .input-title {
  margin-right: 14px;
}

input:disabled {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}

.date {
  font-size: 14px;
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  padding-left: 30px;
  background: #fff;
}

.date.first {
  padding-top: 10px;
}

.title {
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  background: #fff;
  color: #323233;
  padding: 16px 0 10px 20px;
  position: relative;
  margin-bottom: 0;
}

.export-btn {
  position: absolute;
  top: 20px;
  right: 20px;
}

.title span {
  width: 6px;
  height: 14px;
  background: #4fa1a4;
  display: inline-block;
  margin-right: 10px;
}

.row-import {
  display: flex;
  margin-bottom: 20px;
  margin-left: 18px;
}

.row-import .left {
  font-size: 14px;
  font-weight: bold;
  margin-right: 20px;
  padding-top: 4px;
}

.row-import .right {
  font-size: 14px;
}

.tipInfo {
  margin-top: 10px;
  color: #646464;
  line-height: 30px;
}

.task-tips {
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  color: red;
}

.ai-tips {
  height: 26px;
  background: #FFEEE3;
  color: #FF741E;
  line-height: 26px;
  font-size: 13px;
  padding-left: 10px;
}

.download-btns {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  align-items: center;
}

.ai-item .lable {
  font-size: 14px;
  color: #232323;
}

.ai-item {
  margin-top: 20px;
}

.ai-item .value {
  color: #333;
  font-weight: 600;
  margin-left: 5px;
}

.ai-item .other1 {
  color: #333;
  font-weight: 600;
  margin-left: 5px;
}

.ai-item .other2 {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}

.ai-item .ai-color {
  color: #4fa1a4;
  margin-left: 8px;
}

.download-btns .lable {
  font-size: 14px;
  color: #232323;
  flex: 1;
}

.download-btns .btns {
  flex: 1;
  display: flex;
  color: #323233;
  justify-content: flex-end;

}

.download-btns .btn1 {
  margin-right: 20px;
}

.download-btns .btn1,
.download-btns .btn2 {
  border: 1px solid #D9D9D9;
  padding: 6px;
  border-radius: 4px;
}

/deep/.ai-class .el-dialog--center .el-dialog__body {
  padding: 0 25px;
}

.iframe-sty {
  width: 100%;
  border: none;
  height: 600px;

}

.flow {
  background: #fff;
  padding-left: 20px;
  margin-top: 4px;
}

.header {
  background: #fff;
  margin: 1px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;

}

.header .back {
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}

.header .task-title {
  flex: 1;
  font-weight: 500px;
}

.basic-conetent {
  background: #fff;
  margin-bottom: 4px;
}

.btn-groups {
  background: #fff;
  padding-top: 4px;
}

.btn-groups .btn-common {
  width: 120px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.btn-border-green {
  background: #fff;
  color: #4fa1a4;
  border: 1px solid #4fa1a4;
}

.btn-border-gray {
  background: #f0f0f0;
  color: #323233;
  border: 1px solid #dcdee0;
}

.btn-operate {
  text-align: left;
}

.btn-operate .btn-common {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}

.sum-txt {
  background: #fff;
  text-align: left;
  padding-left: 30px;
}

.btn-operate .btn-common:last-child {
  margin-right: 30px;
}

.approve-item-list {
  display: flex;
  background: #fff;
  margin-bottom: 4px;
  align-items: center;
  padding-bottom: 16px;
  position: relative;
}

.approve-item-list .item {
  margin-left: 40px;
  display: flex;
}

.approve-item-list .label {
  color: #606266;
  margin-right: 15px;
}

.approve-item-list .item.first {
  margin-left: 50px;
}

.approve-item-list img {
  position: absolute;
  right: 40px;
  width: 70px;
  bottom: 8px;
}
.content-main-box{
  height:auto;
}
</style>
